import { PopOverMenu } from "components/UI/PopOverMenu";
import { PopoverProps } from "@mui/material";
import { IGroup } from "components/UI/PopOverMenu/PopOverMenu";
import "./MoreMenu.scss";

interface IMoreMenuProps {
  isOpen: boolean;
  menuProps: Partial<PopoverProps>;
  onClose: () => void;
  menuItems: IGroup[];
  isFullscreen?: boolean;
}

export const MoreMenu: React.FC<IMoreMenuProps> = (props) => {
  return (
    <PopOverMenu
      className="MoreMenu"
      title="Options"
      {...props}
    />
  );
};
